function confine(value, min, max) {
  return value < min ? min : value > max ? max : value;
}
const MIN = 1;
const MAX = {
  product_segment: 15,
  product_catalog: 100
};

export default {
  name: 'ProductSourceDisplaySettings',
  props: ['data', 'translations'],
  methods: {
    setMinimum(event) {
      this.minimum = Number(confine(Number(event.detail.value), MIN, this.data.limit));
    },
    setLimit(event) {
      this.limit = Number(confine(Number(event.detail.value), this.data.minimum, this.maximum));
    }
  },
  computed: {
    minimum: {
      get() {
        return this.data.minimum;
      },
      set(value) {
        this.$emit('changed', { ...this.data, minimum: value });
      }
    },
    maximum: {
      get() {
        return MAX[this.data.selectedGroup];
      }
    },
    limit: {
      get() {
        return this.data.limit;
      },
      set(value) {
        this.$emit('changed', { ...this.data, limit: value });
      }
    }
  }
};
